<template lang="">
  <div>
    <div class="container">
      <div class="main-result">
        <Form :model="formItem" :label-width="80">
          <FormItem label="企业代码">
            <Input
              @click="SelectClientSwitch = !SelectClientSwitch"
              v-model="formItem.clientCode"
              type="text"
              placeholder="企业代码"
            ></Input>
          </FormItem>
          <FormItem label="名称">
            <Input
              v-model="formItem.user_name"
              type="text"
              placeholder="名称"
            ></Input>
          </FormItem>

          <FormItem label="手机号">
            <Input
              v-model="formItem.user_phone"
              type="text"
              placeholder="手机号"
            ></Input>
          </FormItem>

          <FormItem label="登录密码">
            <Input
              v-model="formItem.user_password"
              type="password"
              :autosize="{ minRows: 2, maxRows: 5 }"
              placeholder="登录密码"
            ></Input>
          </FormItem>

          <FormItem label="所属仓库">
            <Input
              v-model="formItem.store_name"
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 5 }"
              placeholder="所属仓库"
            ></Input>
          </FormItem>

          <FormItem label="备注">
            <Input
              v-model="formItem.remark"
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 5 }"
              placeholder="备注"
            ></Input>
          </FormItem>

          <FormItem>
            <Button type="primary" @click="updatas()">提交</Button>
          </FormItem>
        </Form>
      </div>
    </div>
  </div>
</template>
<script>
import { updataStoraUserList } from "@/api/index";
export default {
  data() {
    return {
      formItem: {
        clientCode: "",
        remark: "",
        store_name: "",
        user_name: "",
        user_phone: "",
        user_password: "",
        store_code: "",
        id:''
      },
    };
  },
  props: ["ResultDate"],
  components: {},
  beforeCreate() {},
  mounted() {},
  updated() {},
  watch: {
    ResultDate(news, olds) {
      this.formItem = {
        clientCode: news.clientCode,
        remark: news.remark,
        store_name: news.store_name,
        user_name: news.user_name,
        user_phone: news.user_phone,
        user_password: news.user_password,
        store_code: news.store_code,
        id: news.id,
      };
    },
  },
  methods: {
    updatas() {
      updataStoraUserList({
        obj: this.formItem,
      }).then((res) => {
        if (res) {
          this.$emit("resultDates", this.formItem);
        }
      });
    },
  },
};
</script>
<style scoped >
.top {
  width: 100%;
  background: white;
  padding: 15px;
  display: flex;
  flex-direction: row;
}

.select {
  margin-left: 10px;
}

.main {
  background: white;
  display: flex;
  flex-direction: column;
  align-items: left;
}

.page {
  margin-top: 20px;
  margin-bottom: 20px;
}
</style>
